var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('loading',{attrs:{"name":"load menu"}},[_c('router-view',{attrs:{"name":"nav"}}),_c('router-view'),(!_vm.$wait.any)?_c('router-view',{attrs:{"name":"footer"}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }